<div class="card card-box">
    <div class="card-header">
        <div class="display-5  card-header--title font-weight-bold" style="font-size: 16px;">
            Concierge Payroll Report
        </div>
        <div class="card-header--actions">
            <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" (click)="showFilter()"
                    dropdownToggle type="button">
                    <span class="btn-wrapper--label">Filters</span>
                    <span class="btn-wrapper--icon">
                        <fa-icon *ngIf="!isShow" [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1">
                        </fa-icon>
                        <fa-icon *ngIf="isShow" [icon]="['fas', 'chevron-up']" class="opacity-8 font-size-xs ml-1">
                        </fa-icon>
                    </span>
                </button>
            </div>
            <button (click)="exportExcel()" tooltip="Excel" id="excelBtn"
                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                type="button">
                <fa-icon [icon]="['far', 'file-excel']" class="h5 d-block mb-2 mt-1 text-primary btn-wrapper--icon">
                </fa-icon>
            </button>
            <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                <button tooltip="Refresh" (click)="onReset()"
                    class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                    type="button">
                    <span class="btn-wrapper--icon">
                        <i class="ion-md-sync"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div>
            <div class=" justify-content-between">
                <div *ngIf="isShow">
                    <form [formGroup]="filters_form" novalidate>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label> Reservation Type</label>
                                    <ng-select formControlName="resType" [multiple]="true">
                                        <div *ngFor="let contract of contracts">
                                            <ng-option value="{{contract.contractId}}">
                                                {{contract.contractId}}</ng-option>
                                        </div>
                                    </ng-select>
                                    <!-- <ng-select formControlName="resType" [multiple]="true">
                                        <ng-option value="AMEX">AMEX </ng-option>
                                        <ng-option value="Retail">Retail </ng-option>
                                        <ng-option value="Retail-Web">Retail-Web </ng-option>
                                    </ng-select> -->
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Reservation From Date</label>
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                </fa-icon>
                                            </span>
                                        </div>
                                        <input [bsConfig]="{
                                containerClass: 'theme-primary',
                                isAnimated: true,
                                customTodayClass: 'custom-today-class'
                              }" bsDatepicker formControlName="startdate" class="form-control"
                                            placeholder="Select date" type="text" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Reservation To Date</label>
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                </fa-icon>
                                            </span>
                                        </div>
                                        <input [bsConfig]="{
                                containerClass: 'theme-primary',
                                isAnimated: true,
                                customTodayClass: 'custom-today-class'
                              }" bsDatepicker formControlName="enddate" class="form-control" placeholder="Select date"
                                            type="text" />
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-3">
                                <div class="form-group">
                                    <label> Reservation Status</label>
                                    <ng-select formControlName="resStatus" [multiple]="true">
                                        <div *ngFor="let resStatus of reservationStatusList">
                                            <ng-option [value]="resStatus.resStatusId">
                                                {{resStatus.resBoText}}</ng-option>
                                        </div>
                                    </ng-select>
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label> Stations</label>
                                    <ng-select [multiple]="true" formControlName="stationcodes">
                                        <div *ngFor="let station of stations">
                                            <ng-option [value]="station.stationid">
                                                {{station?.stationid}} - {{station?.airportName}}</ng-option>
                                        </div>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-label" for="isCapitalOne">Promotional Contract</label>
                                    <ng-select
                                            [items]="yesNoOptions"
                                            bindLabel="label"
                                            bindValue="value"
                                            [multiple]="true"
                                            formControlName="isCapitalOne"
                                    >
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group pt-4">
                                    <button class="btn  mt-2 btn-sm btn-block btn-primary btn-square" type="button"
                                        (click)="onFilter(filters_form.value)">
                                        Search
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group pt-4">
                                    <button class="btn btn-sm mt-2  btn-block btn-primary btn-square" type="button"
                                        (click)="onReset()">
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="d-flex justify-content-between pb-3">
                    <div class="search-wrapper">
                        <span class="icon-wrapper text-black">
                            <fa-icon [icon]="['fas', 'search']"></fa-icon>
                        </span>
                        <input type="text" class="form-control form-control-sm rounded-pill"
                            placeholder="ResID, Station, Concierge" [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="searchText" />
                    </div>
                </div>
                <div *ngIf="conciergeGreetData | tsearch: searchText; let filtereddayBeforeData">
                    <div class="table-responsive table-scroll">
                        <table id="report25con" class="table table-hover table-striped table-bordered text-nowrap mb-3"
                            [mfData]="filtereddayBeforeData" #mf="mfDataTable" [mfRowsOnPage]="100">
                            <thead>
                                <tr>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="resId">Res ID</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="resId">Promotional Contract</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="linkedResId">Retail Res ID</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="res_Type">Res Type</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="AirportIATA">Station</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="emp_id">Employee ID</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="firsname">Primary Concierge</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="firsname">Secondary Concierge</mfDefaultSorter>
                                    </th>


                                    <th class="bg-white text-left">
                                        <mfDefaultSorter by="RES_STATUS">Res Status</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">Primary Concierge Status</th>
                                    <th class="bg-white text-left">Billing Status</th>
                                    <th class="bg-white text-left">
                                        <mfDefaultSorter>Direction</mfDefaultSorter>
                                    </th>
                                    <th class="bg-white text-left">Greet Date</th>
                                    <th class="bg-white text-left">Greet Start</th>
                                    <th class="bg-white text-left">Greet End</th>
                                    <th class="bg-white text-left">Worked Hours </th>
                                    <th class="bg-white text-left">Secondary Concierge Greet Start</th>
                                    <th class="bg-white text-left">Secondary Concierge Greet End</th>
                                    <th class="bg-white text-left">Secondary Worked Hours </th>
                                    <th class="bg-white text-left">Notes</th>
                                    <th class="bg-white text-left">Credit Service Failure</th>
                                    <th class="bg-white text-left">Credit Service Failure Reason</th>
                                    <th class="bg-white text-left">Credit Service Failure Notes</th>
                                    <th class="bg-white text-left">Credit Service Amount</th>
                                    <th class="bg-white text-left">Physcical Contact</th>
                                    <th class="bg-white text-left">Client Happy</th>
                                    <th class="bg-white text-left">Additional Labour Hours</th>
                                    <th class="bg-white text-left">Carts</th>
                                    <th class="bg-white text-left">Bags</th>
                                    <th class="bg-white text-left">Service Tip Amount </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let greet of mf.data let i=index;">
                                    <td class="text-left">
                                        {{greet.resId}}
                                    </td>
                                    <td class="text-left">
                                        <div *ngIf="greet?.is_capital_one">
                                            Capital One
                                        </div>
                                    </td>
                                    <td class="text-left">
                                        {{greet.linkedResId}}
                                    </td>
                                    <td class="text-left">
                                        {{greet.res_Type}}
                                    </td>
                                    <td class="text-left">
                                        {{greet.AirportIATA}}
                                    </td>
                                    <td class="text-left">
                                        {{greet.emp_id}}
                                    </td>
                                    <td class="text-left">
                                        {{greet.firstname}} {{greet.lastname}}
                                    </td>
                                    <td class="text-left">
                                        {{greet.SecondaryAgent}}
                                    </td>
                                    <td class="text-left ">
                                        <span style="color: #011e41;">{{greet.RES_STATUS}}
                                        </span>
                                    </td>

                                    <td class="text-left ">
                                        <span *ngIf="greet?.GREET_SERVICE_AGENT_STATUS === 'CP'">Complete</span>
                                        <span *ngIf="greet?.GREET_SERVICE_AGENT_STATUS === 'CPNR'">Needs Review</span>
                                        <span *ngIf="greet?.GREET_SERVICE_AGENT_STATUS === 'UFSNR'">Unfulfilled
                                            Service</span>
                                    </td>
                                    <td class="text-left ">
                                        {{greet.GREET_SERVICE_BACKOFFICE_STATUS}}
                                    </td>
                                    <td class="text-left">
                                        <span *ngIf="greet.ServiceDirectionID == 'A'">
                                            Arrival
                                        </span>
                                        <span *ngIf="greet.ServiceDirectionID == 'D'">
                                            Departure
                                        </span>
                                        <span *ngIf="greet.ServiceDirectionID == 'X'">
                                            Transfer
                                        </span>

                                    </td>
                                    <td class="text-left ">
                                        <span>{{getDate(greet.StartDT)}}
                                        </span>
                                    </td>
                                    <td class="text-left ">
                                        <span>{{greet.greetStartTime}}
                                        </span>
                                    </td>
                                    <td class="text-left ">
                                        <span>{{greet.greetEndTime}}
                                        </span>
                                    </td>
                                    <td class="text-left">
                                        {{greet.workedHours}}
                                    </td>
                                    <td class="text-left ">
                                        <span>{{greet.SecondaryGreetStartTime}}
                                        </span>
                                    </td>
                                    <td class="text-left ">
                                        <span>{{greet.SecondaryGreetEndTime}}
                                        </span>
                                    </td>
                                    <td class="text-left">
                                        {{greet.SecondaryWorkedHours}}
                                    </td>
                                    <td class="text-left ">
                                        <span> {{greet.notes}}</span>
                                    </td>
                                    <td class="text-left ">
                                        {{greet.CREDIT_SERVICE_FAILURE}}
                                    </td>
                                    <td class="text-left ">
                                        {{greet.CREDIT_SERVICE_FAILURE_REASON}}
                                    </td>
                                    <td class="text-left ">
                                        {{greet.CREDIT_SERVICE_FAILURE_NOTES}}
                                    </td>
                                    <td class="text-left ">
                                        {{greet.CREDIT_SERVICE_AMOUNT}}
                                        <span *ngIf="greet.CREDIT_SERVICE_AMOUNT"> %</span>
                                    </td>
                                    <td class="text-left ">
                                        {{greet.PHYSICAL_CONTACT}}
                                    </td>
                                    <td class="text-left ">
                                        {{greet.CLIENT_HAPPY}}
                                    </td>
                                    <td class="text-left ">
                                        {{greet.ADDITIONAL_LABOUR_HOURS}}
                                    </td>

                                    <td class="text-left ">
                                        {{greet.CARTS}}
                                    </td>

                                    <td class="text-left ">
                                        {{greet.BAGS}}
                                    </td>
                                    <td class="text-left ">
                                        {{greet.SERVICE_TIP_AMOUNT}}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="25">
                                        <span class="font-weight-bold">Total Records: {{
                                            filtereddayBeforeData.length
                                            }}</span> &nbsp;&nbsp;&nbsp;
                                        <mfBootstrapPaginator [rowsOnPageSet]="[100, 200, 300]">
                                        </mfBootstrapPaginator>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>